import { ToastConfig } from './types';

export const defaultToastConfig: ToastConfig = {
  position: {
    top: 100
  },
  animation: {
    fadeOut: 300,
    fadeIn: 200
  }
};
